import * as React from 'react'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Image from 'next/image'
import { useRouter } from 'next/router'

import { useAppSelector } from '#/app/store/store'
import { addReferral } from '#/entities/user-account/model/user-type-slice'
import { RegisterEmailForm } from '#/features/register-by-email'
import { YandexAuthButton } from '#/features/yandex-auth-button'
import { NextPageWithLayout } from '#/pages/_app'
import { getDeviceType } from '#/shared/lib/helpers'

import styles from './register.module.scss'

const Register: NextPageWithLayout = () => {
	const device = getDeviceType()

	const desktop = device === 'desktop'

	const [success, setSuccess] = useState(false)
	const [isReferral, setIsReferral] = useState<boolean>(true)

	const referral = useAppSelector((state) => state.user.referral)
	const dispatch = useDispatch()

	const { query, push } = useRouter()
	const [, setCookie] = useCookies()

	React.useEffect(() => {
		Object.entries(query).forEach(([key, value]) => setCookie(key, value))
	}, [query])

	const onSuccessRegister = () => {
		setSuccess(true)
		setTimeout(() => push('/login'), 15000)
	}

	useEffect(() => {
		if (localStorage.getItem('referral')) {
			setIsReferral(false)
			dispatch(addReferral(localStorage.getItem('referral')))
		} else {
			setIsReferral(true)
		}
	}, [])

	return (
		<Stack
			className={styles.page}
			direction={desktop ? 'row' : 'column'}
			alignItems='center'
			justifyContent={desktop ? 'space-between' : 'center'}
			sx={{
				overflow: 'hidden',
				padding: 0,
				margin: desktop ? 0 : '0px auto',
				backgroundColor: '#303035',
			}}
		>
			{!desktop && (
				<Image
					className={styles.logoMobile}
					src={'/logo.svg'}
					alt={''}
					width={50}
					height={50}
				/>
			)}
			<Box
				className={`${styles.form} ${styles.formPanel}`}
				sx={{
					width: desktop ? '50%' : '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					marginTop: desktop ? 0 : '10px',
				}}
			>
				<Box
					className={styles.formContent}
					sx={{
						marginTop: desktop ? 0 : 2,
						justifyContent: 'center',
						alignItems: 'center',
						display: 'flex',
					}}
				>
					{success ? (
						<Box textAlign='center'>
							<Typography className='text'>
								Вы успешно зарегистрированы.
								<br />
								Мы отправили письмо для верификации на ваш email. В случае отсутствия, проверьте
								папку Спам.
								<br />
								<br />
								Если вы регистрировались с корпоративной почты и письмо-подтверждение вам не
								пришло, рекомендуем зарегистрироваться с личной почты
							</Typography>
						</Box>
					) : (
						<Stack direction='column' justifyContent='center' alignItems='center' spacing={1}>
							<Typography
								sx={{
									color: '#E1E1E1',
									lineHeight: '36.4px',
									fontSize: '26px',
									fontWeight: 'bold',
									marginBottom: '20px',
								}}
							>
								Регистрация
							</Typography>

							{referral === '' && isReferral && (
								<YandexAuthButton>Зарегистрироваться с Яндекс ID</YandexAuthButton>
							)}
							<RegisterEmailForm successLogin={onSuccessRegister} />
						</Stack>
					)}
				</Box>
			</Box>
			{desktop && (
				<Box
					className={`${styles.imagebox} ${styles.promoPanel}`}
					sx={{
						width: '50%',
						backgroundColor: '#8280FF',
						overflow: 'hidden',
						position: 'relative',
					}}
				>
					<Image
						className={styles.imageboxLogo}
						src={'/svg/logo.svg'}
						alt={''}
						width={42}
						height={42}
					/>
					<Image
						src={'/images/dashboard.png'}
						alt={''}
						width={900}
						height={1002}
						className={styles.promoDashboardImage}
					/>
				</Box>
			)}
		</Stack>
	)
}

export default Register
